/**
 * @fileoverview When a user selects a country from a dropdown, change the address form
 * Note: This file is used in internal admin tools, storm, and (eventually) spark.  Be very careful
 * when making changes!
 *
 * Note also: Because different parts of our system use different versions of jQuery, we store a
 * version of jquery 1.10 on the InternationalAddressSelector object - use this.jq110 instead of $ to
 * access various jQuery functionality.
 */
(function() {
  /**
   * @constructor
   */
  var InternationalAddressSelector = function(addressObjectName, changeCallback, jq110) {
    this.jq110 = jq110;
    this.changeCallback = changeCallback;
    this.addressObjectName = addressObjectName;
    this.$container = this.jq110('.js-country-address-form');
    this.$countrySelector = this.jq110('.js-country-select-element');
    // A custom callback function to be called upon completion of a country
    // change. The callback is removed after a single invocation. This is useful
    // if upon init, we need to change the country field and fill out the form.
    this.customInitialChangeCallback = null;

    this.previouslyDisplayedCountryHtml = {};
    this.bindChangeAddressForm();
    this.bindSubmitEnablers();
    this.bindShowHideLines();
    this.bindServiceArea();

    var countryCode = this.$countrySelector.val();
    // Sometimes the country selector is not displayed when users can't switch the country
    if (!countryCode) {
      var $countryInput = $('input[name=\'address.country\']');
      if ($countryInput.length) {
        countryCode = $countryInput.attr('value');
      }
    }
    this.generateDivisionDropdown(countryCode, this.$container);
  };
  window.InternationalAddressSelector = InternationalAddressSelector;

  /**
   * Wrapper around enableSubmit function so we can call it without worrying about whether
   * we're in storm where it's defined
   */
  InternationalAddressSelector.prototype.enableSubmit = function(form) {
    if (typeof window.enableSubmit === 'function') {
      window.enableSubmit(form);
    }
  };

  InternationalAddressSelector.prototype.selectboxIfPossible = function($select) {
    if (typeof $select.selectbox === 'function') {
      $select.selectbox();
    }
  };

  InternationalAddressSelector.prototype.bindShowHideLines = function() {
    var $addressInputDiv = this.$container.find('.js-address-edit');
    var $addExtraLine = $addressInputDiv.find('.add-extra-line');
    var $extraLineInput = $addressInputDiv.find('.extra-line-input');
    var $displayAddress = this.jq110('[name="' + this.addressObjectName + 'displayAddress"]');
    var that = this;

    /**
     * @param {boolean} show true to show input, false to show link to add extra line.
     */
    var showInput = function(show) {
      $addExtraLine.toggle(!show);
      $extraLineInput.toggle(show);
    };

    showInput($displayAddress.val() !== '');

    $addressInputDiv.on('click', '.add-extra-line', function() {
      showInput(true);
    });

    $addressInputDiv.on('click', '.extra-line-remove', function() {
      showInput(false);
      $displayAddress.val('');
      that.enableSubmit('.address-field-edit');
    });
  };

  /**
   * Bind the service area section
   * @suppress {deprecated}
   */
  InternationalAddressSelector.prototype.bindServiceArea = function() {
    var $ctx = $('.js-service-area-container');
    if ($ctx.length) {
      var $hasServiceArea = $('.js-has-service-area');
      var $radioPlaces = $('.js-type-places');
      var $radioDistance = $('.js-type-distance');
      var $radius = $('.js-radius-input');
      var $newPlace = $('.js-new-place-input');
      var $selectedPlaces = $('.js-selected-places');

      var placeTemplate = function(place) {
        return '<li>' +
          '<i class="remove-item js-remove-item"></i>' + place +
          '<input type="hidden" name="address.serviceAreaPlace" value="' + place + '">' +
          '</li>';
      };

      var updated = function() {
        window.enableSubmit($newPlace[0].form);
      };

      var addNewPlace = function() {
        if ($.trim($newPlace.val())) {
          $radioPlaces.prop('checked', true).trigger('change');
          var html = placeTemplate($.trim($newPlace.val()));
          $selectedPlaces.append(html);
          $newPlace.val('').focus();
          updated();
        }
      };

      $hasServiceArea.click(function() {
        $ctx.toggle($hasServiceArea.prop('checked'));
        updated();
      });

      $radioPlaces.change(function() {
        if ($radioPlaces.prop('checked')) {
          $radius.prop('disabled', true);
          $selectedPlaces.removeClass('deselected');
          updated();
        }
      });

      $radioDistance.change(function() {
        if ($radioDistance.prop('checked')) {
          $radius.prop('disabled', false);
          $radius.focus();
          $selectedPlaces.addClass('deselected');
          updated();
        }
      });

      $('.js-radius-units').change(updated);

      $ctx.find('.js-new-place-button').click(addNewPlace);

      $selectedPlaces.on('click', '.js-remove-item', function() {
        $(this).closest('li').remove();
        updated();
      });

      // Enter will add a new place instead of submitting address form
      $newPlace.on('keydown', function(e) {
        if (e.keyCode == $.ui.keyCode.ENTER) {
          e.preventDefault();
          e.stopImmediatePropagation();
          addNewPlace();
          return false;
        }
      });

      $radius.on('change input keyup', function() {
        if (!$radioDistance.prop('checked')) {
          $radioDistance.prop('checked', true).trigger('change');
        }
        updated();
      });
    }
  };

  InternationalAddressSelector.prototype.bindSubmitEnablers = function() {
    var that = this;
    this.jq110('.js-address-edit').on('change', '.international-address-submit-enabler', function() {
      that.enableSubmit(this.form);
    });
  };

  InternationalAddressSelector.prototype.bindChangeAddressForm = function(e) {
    var prevCountryCode = this.$countrySelector.val();
    var that = this;

    this.$countrySelector.change(function() {
      var countryCode = that.$countrySelector.val();
      // Only do stuff if country was actually changed
      if (countryCode !== prevCountryCode) {
        that.countryChange(countryCode);
        var $addressEdit = that.$container.find('.js-address-edit');
        var $cloneToSave = that.$container.find('.address-table').clone();
        // JQuery clone doesn't actually preserve select values, so we need to manually store them
        that.jq110('.address-table').find('select').each(function(i, elem) {
          $cloneToSave.find('select').eq(i).val(that.jq110(elem).val());
        });
        that.previouslyDisplayedCountryHtml[prevCountryCode] = $cloneToSave;
        var timeoutId = null;
        // Since we may not actually be in storm where this is defined...
        if (typeof window.showDelayedProgressDialog !== 'undefined') {
          timeoutId = window.showDelayedProgressDialog();
        }

        if (that.previouslyDisplayedCountryHtml.hasOwnProperty(countryCode)) {
          that.jq110('#phone-country').val(countryCode);

          $addressEdit.fadeOut(function() {
            $addressEdit.empty();
            $addressEdit.html(that.previouslyDisplayedCountryHtml[countryCode]);
            // We need to re-selectbox the selects so they're connected to the newly-cloned elements
            $addressEdit.find('.selectbox').remove();
            $addressEdit.find('select').each(function(i, elem) {
              that.selectboxIfPossible(that.jq110(elem));
            });

            if (typeof that.changeCallback === 'function') {
              that.changeCallback(countryCode);
            }

            that.generateDivisionDropdown(countryCode);
            that.bindShowHideLines();
            that.bindSubmitEnablers();
            $addressEdit.fadeIn();
            if (timeoutId != null) {
              window.hideDelayedProgressDialog(timeoutId);
            }
          });
          that.customInitialChangeCallback = null;
        } else {
          that.jq110.get(
            window.getAddressFormForCountry,
            {countryCode: countryCode,
              addressObjectName: that.addressObjectName,
              customInputNamesEncoded: window.customAddressInputNamesAndValues})
            .success(function(data) {
              $addressEdit.fadeOut(function() {
                // Replace form contents
                $addressEdit.replaceWith(data);

                // reassign $addressEdit because replaceWith replaces the old addressEdit object
                $addressEdit = that.$container.find('.js-address-edit');

                $addressEdit.find('select').each(function(i, elem) {
                  that.selectboxIfPossible(that.jq110(elem));
                });

                // Update some other things
                that.jq110('#phone-country').val(countryCode);
                if (typeof that.changeCallback === 'function') {
                  that.changeCallback(countryCode);
                }
                that.generateDivisionDropdown(countryCode);
                that.bindShowHideLines(that.addressObjectName);
                that.bindSubmitEnablers();

                if (that.customInitialChangeCallback) {
                  that.customInitialChangeCallback();
                  that.customInitialChangeCallback = null;
                }

                // Show new form
                $addressEdit.fadeIn();
              });
            })
            .done(function() {
              if (timeoutId != null) {
                window.hideDelayedProgressDialog(timeoutId);
              }
            })
            .fail(function() {
              that.customInitialChangeCallback = null;
            });
        }
        prevCountryCode = countryCode;
      }
    });
  };

  /**
   * Update language dropdown to reflect country
   * @param {string} newCountry the country that was changed to
   */
  InternationalAddressSelector.prototype.countryChange = function(newCountry) {
    var $businessLanguage = $('.js-business-language');
    var self = this;
    var options = [];
    $.get(
      window.getCountryLanguages, {
        countryCode: newCountry,
      },
      function(response) {
        for (var i = 0; i < response.length; i++) {
          options.push(self.selectOption(response[i].code, response[i].displayName, response[i].primary));
        }
        $businessLanguage.html(options.join(''));
      },
    );
  };

  /**
   * format arguments into dropdown option html
   * @param {string} value the option's value
   * @param {string} label the option's label
   * @param {boolean} selected whether this option is the default selected one
   * @return {string} the formatted option html
   */
  InternationalAddressSelector.prototype.selectOption = function(value, label, selected) {
    return '<option value="'+ value +'"' + (selected ? ' selected':'') + '>'+ label + '</option>';
  };

  /**
   * Logic for generating the dropdowns per division for specific locations
   * @param {string} countryCode country code for which we render dropdowns
   */
  InternationalAddressSelector.prototype.generateDivisionDropdown = function(countryCode) {
    if (countryCode === 'CN') {
      this.generateDivisionCn();
    }
  };

  /**
   * Location division logic for China
   */
  InternationalAddressSelector.prototype.generateDivisionCn = function() {
    var $addressTable = this.$container.find('.address-table');
    var $cnProvinceDropdown = $addressTable.find('select.state');
    var $cnCityDropdown = $addressTable.find('select.city');
    var $cnCityDropdownTextField = $addressTable.find('.cn-city-textfield');
    var $cnDistrictDropdown = $addressTable.find('select.sublocality');
    var $cnDistrictDropdownTextField = $addressTable.find('.cn-district-textfield');
    var that = this;

    var cnDivisionData = {};
    var provinceKey = '';

    /**
     * Load possible city choices in the dropdown
     * @param {string} provinceEn the province in english
     */
    var _loadCityChoices = function(provinceEn) {
      for (var provinceObjectIndex in cnDivisionData) {
        if (cnDivisionData[provinceObjectIndex]['en'] == provinceEn) {
          provinceKey = Object.keys(cnDivisionData[provinceObjectIndex])[1]; // Province in Chinese
          var _cityList = cnDivisionData[provinceObjectIndex][provinceKey]; // List of objects that contain the cities

          for (var cityIndex in _cityList) {
            var _city = Object.keys(_cityList[cityIndex])[0];
            $cnCityDropdown
              .append(that.jq110('<option>', {value: _city})
                .text(_city));
          }
          break;
        }
      }
    };

    /**
     * Load possible district choices in the dropdown
     * @param {string} city name of the city of the district in Chinese
     * @param {number} selectedIndex the nth item inside the list of the province object that is the city
     */
    var _loadDistrictChoices = function(city, selectedIndex) {
      var _districtList = cnDivisionData[provinceKey][provinceKey][(selectedIndex-1)][city]; // required for structure of JSON

      for (var districtIndex in _districtList) {
        var district = _districtList[districtIndex];
        $cnDistrictDropdown
          .append(that.jq110('<option>', {value: district})
            .text(district));
      }
    };

    /**
     * Update district dropdown to reflect the city
     */
    var _cityChange = function() {
      var $this = that.jq110(this);
      var selectedIndex = this.selectedIndex;

      _resetDropdown($cnDistrictDropdown);

      if ($this.val()) {
        $cnDistrictDropdown.prop('disabled', false).change();
        _loadDistrictChoices($this.val(), selectedIndex);
      }
    };

    /**
     * Update city dropdown to reflect the province
     */
    var _provinceChange = function() {
      var $this = that.jq110(this);
      _resetDropdown($cnCityDropdown);
      _resetDropdown($cnDistrictDropdown);

      if ($this.val()) {
        $cnCityDropdown.prop('disabled', false).change();
        _loadCityChoices($this.val());
      }
    };

    /**
     * Update city dropdown to reflect the province
     * @param {!jQuery} $division dropdown to be reset
     */
    var _resetDropdown = function($division) {
      $division.find('option:selected')
        .removeAttr('selected').end()
        .html('<option value="">--</option>')
        .prop('disabled', true)
        .change();
    };

    /**
     * Populate dropdowns with state/city/sublocality, fallback to textfield
     */
    var _populateDropdown = function() {
      var _state = that.$container.find('.cn-state-data').val();
      var _city = that.$container.find('.cn-city-data').val();
      var _sublocality = that.$container.find('.cn-sublocality-data').val();

      if (_state || _city || _sublocality) {
        $cnProvinceDropdown.val(_state).change();

        if (_validDropdownChoice($cnCityDropdown, _city)) {
          $cnCityDropdown.val(_city).change();

          if (_validDropdownChoice($cnDistrictDropdown, _sublocality)) {
            $cnDistrictDropdown.val(_sublocality).change();
          } else {
            _activateFallbackTextField($cnDistrictDropdown, $cnDistrictDropdownTextField, _sublocality);
          }
        } else {
          _activateFallbackTextField($cnCityDropdown, $cnCityDropdownTextField, _city);
          _activateFallbackTextField($cnDistrictDropdown, $cnDistrictDropdownTextField, _sublocality);
        }
      }
    };

    /**
     * Generates the text field to replace dropdown if choice is not found
     * @param {!jQuery} $division dropdown object
     * @param {!jQuery} $divisionTextField textfield object
     * @param {string} value preloaded value
     */
    var _activateFallbackTextField = function($division, $divisionTextField, value) {
      $division
        .next('.selectbox').remove().end()
        .remove();
      $divisionTextField
        .show()
        .prop('disabled', false)
        .val(value);
    };

    /**
     * Check if the given value is a valid choice for the dropdown
     * @param {!jQuery} $division dropdown object
     * @param {string} choice value of field
     * @return {boolean} whether or not the choice exists in the dropdown
     */
    var _validDropdownChoice = function($division, choice) {
      var _exists = false;
      $division.find('option').each(function() {
        if (this.value == choice) {
          _exists = true;
          return false; // break out of loop
        }
      });
      return _exists;
    };

    that.jq110.getJSON(window.chinaJsonUrl, function(data) {
      $cnProvinceDropdown
        .html('<option value="">--</option>')
        .prop('disabled', false)
        .change();

      for (var provinceObject in data) {
        var province = Object.keys(data[provinceObject])[1];
        var provinceEn = data[provinceObject]['en'];
        cnDivisionData[province] = data[provinceObject];
        $cnProvinceDropdown
          .append(that.jq110('<option>', {value: provinceEn})
            .text(provinceEn + ' (' + province + ')'));
      }

      that.selectboxIfPossible($cnProvinceDropdown);
      that.selectboxIfPossible($cnCityDropdown);
      that.selectboxIfPossible($cnDistrictDropdown);

      _resetDropdown($cnCityDropdown);
      _resetDropdown($cnDistrictDropdown);

      // Intialize bindings
      $cnProvinceDropdown.on('change', _provinceChange);
      $cnCityDropdown.on('change', _cityChange);
      _populateDropdown();
    })
      .fail(function() {
        // TRANSLATORS: Could not load a Chinese geographical information
        window.showErrorDialog(yext.msg('Unable to load China location data.'),
          yext.msg('Error'));
      });
  };
})();
